export default {
  state: {
    successRegister: "",
  },
  mutations: {
    setSuccessRegister: (state, payload) => (state.successRegister = payload),
  },
};
